import { service } from "infrastructure";
import { isSuccessResponse } from "presentation/common";

export async function loadDocumentsAction(state, dispatch) {
  try {
    const user = state.auth.user;
    const response = await service.getMyDocuments(user);

    if (isSuccessResponse(response)) {
      dispatch.myDocuments.loadDocumentsSuccessAction(response.data || []);
    }
  } catch (e) {}
}
